import { createSelector } from '@ngrx/store';
import { selectRoles } from './roles.selector';
import { selectPermissions } from './permissions.selector';
import { selectTags } from './tags.selector';
import { selectForms } from './forms.selector';

export const selectRolesLoaded = createSelector(
  selectRoles,
  roles => roles != null
);

export const selectPermissionsLoaded = createSelector(
  selectPermissions,
  permissions => permissions != null
);

export const selectTagsLoaded = createSelector(
  selectTags,
  tags => tags != null
);

export const selectFormsLoaded = createSelector(
  selectForms,
  forms => forms != null
);
